import stylesControllerMixin from '@/mixins/stylesControllerMixin'

export default {
    mixins: [stylesControllerMixin],

    computed: {
        fill() {
            return this.isCurrentScene
                ? { fill: '#F14F1D' }
                : { fill: '#FFFFFF' }
        },

        size() {
            return this.isCurrentScene ? { scale: 1 } : { scale: 0.8 }
        },

        rotate() {
            return this.scene === 'overview' && this.sceneId === 'innovation'
                ? { rotate: 180 }
                : { rotate: 0 }
        },

        styles() {
            return ['size', 'rotate']
        }
    }
}
